export const roles = [
  {
    id: 1,
    title: 'Сотрудник',
    value: 'User',
  },
  {
    id: 1,
    title: 'Hr-специалист',
    value: 'HR manager',
  },
  {
    id: 1,
    title: 'Super Hr-специалист',
    value: 'Super HR Manager',
  },
  {
    id: 1,
    title: 'Руководитель',
    value: 'Manager',
  },
];